import "../Styles/Home.css";
import { FaLinkedinIn, FaGithub } from "react-icons/fa";
import Typical from "react-typical";
import Nikesh_Borkar_Resume from "../Download/Nikesh_Borkar_Resume.pdf";
// import lokesh from "../assets/lokesh-pic.jpg";

const HomePage = () => {
  return (
    <div id="Home">
      <div className="container">
        <div>
          <div className="description">
            <div className="profile-details">
              <div className="colz">
                <div className="colz-icon">
                  <a
                    href="https://www.linkedin.com/in/nikesh-borkar"
                    target="_blank"
                    rel="noreferrer"
                    alt="linked in"
                  >
                    <i className="">
                      <FaLinkedinIn className="icon-ease-out" />
                    </i>
                  </a>
                  <a
                    href="https://github.com/NikeshBorkar"
                    target="_blank"
                    rel="noreferrer"
                    alt="github"
                  >
                    <i className="">
                      <FaGithub className="icon-ease-out" />
                    </i>
                  </a>
                </div>
              </div>

              <div className="profile-details-role">
                <h6>
                  Hello, I'm
                  <span className="highlighted-text">
                    &nbsp;{" Nikesh Borkar "}
                  </span>
                </h6>
                <span className="primary-text">
                  <>
                    <Typical
                      loop={Infinity}
                      steps={[
                        "Enthusiastic Developer",
                        2000,
                        "Full Stack Developer",
                        2000,
                        "Mern Stack Developer",
                        2000,
                        "React-Redux Developer",
                        2000,
                      ]}
                    />
                  </>
                </span>
                <span className="profile-tag-line">
                  Passionate Software Developer with web development
                  technologies. Skilled, collaborative and attentive developer
                  with a drive to develop the most relevant products. Always
                  looking forward to learning something new to strengthen skills
                  learned.
                </span>
              </div>

              <div>
                <a href="#contactSection">
                  <button className="btn primary-btn"> Hire Me </button>
                </a>
                <a href={Nikesh_Borkar_Resume} download>
                  <button className="btn highlighted-btn">Get Resume</button>
                </a>
              </div>
            </div>
          </div>
          <div className="imagebox">
            <div className="profile-picture">
              <div className="profile-picture-background">
                <img
                  src="https://avatars.githubusercontent.com/u/99666800?v=4"
                  alt="NikeshBorkar"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr color="black" id="aboutMePageSection" />
    </div>
  );
};

export default HomePage;
